import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getOTP } from "../../redux/auth/actions";

const useLogin = () => {
  const [mobileNumber, setMobileNumber] = useState("");
  const otpSuccess = useSelector((state) => state.auth.userOTP.success);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleMobileNumberChange = (event) => {
    const { value } = event.target;
    const sanitizedValue = value.replace(/\D/g, "");
    setMobileNumber(sanitizedValue);
  };

  const handleLogin = () => {
    dispatch(getOTP(mobileNumber));
  };

  const signUpHandler = () => navigate("/sign-up");

  useEffect(() => {
    if (otpSuccess) {
      setMobileNumber("");
      navigate("/otp");
    }
    // eslint-disable-next-line
  }, [otpSuccess]);

  return {
    mobileNumber,
    handleMobileNumberChange,
    handleLogin,
    signUpHandler,
  };
};

export default useLogin;
